import { WifiOff } from "lucide-react";
import { useEffect, useState } from "react";

export function ConnectivityStatus() {
  const [online, setOnline] = useState(() => navigator.onLine);
  useEffect(() => {
    const update = () => setOnline(navigator.onLine);
    window.addEventListener("online", update); window.addEventListener("offline", update);
    return () => { window.removeEventListener("online", update); window.removeEventListener("offline", update); };
  }, []);
  return online ? null : <div className="offline-banner"><WifiOff />You’re offline. Reconnect to load data and save transactions.</div>;
}
